<template>
  <div>
    <v-app-bar color="white" height="150">
      <v-toolbar-title>
        <v-img width="360" src="@/assets/img/espacio-honduras.png"></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="mr-4">
        <v-img
          width="360"
          src="@/assets/img/alianza.png"
          @click="irCiat()"
        ></v-img>
      </div>
    </v-app-bar>
    <v-container class="pa-0" fluid>
      <div style="position: relative">
        <v-parallax
          class="pa-0"
          height="500"
          src="https://live.staticflickr.com/7225/7034009207_473f89d41d_h.jpg"
        >
          <div class="fill-height bottom-gradient"></div>
        </v-parallax>
        <div
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          "
        >
          <div
            style="display: flex; flex-direction: column; align-items: center"
          >
            <v-img
              class="mb-2"
              src="@/assets/img/espacioh-center.png"
              width="400"
            ></v-img>
          </div>
        </div>
      </div>
    </v-container>
    <v-container class="mt-4 mb-8">
      <div class="py-4">
        <p class="mb-4" style="font-size: 25pt; text-align: center">
          ESPACIO DE ANÁLISIS TERRITORIAL
        </p>

        <p style="font-size: 20pt; text-align: center">
          Espacio Honduras es el primer sistema de reportes locales a la medida
          de tu municipio, el cual te permitirá identificar cuáles son las áreas
          donde es más importante desarrollar estrategias para transformar la
          calidad de vida de tu comunidad, basándote en datos precisos y
          proyecciones que te permitirán entender los reto que presenta el
          cambio climático en tu región.
        </p>
      </div>

      <div style="display: flex; justify-content: space-evenly;">
        <v-btn :color="publicationType == 'single' ? 'green': 'gray'" class="mb-6 py-4" style="font-size: 14pt; text-align: center" @click="() => this.publicationType = 'single'">
          REPORTES POR MUNICIPIO
        </v-btn>
        <v-btn :color="publicationType == 'multiple' ? 'green': 'gray'" class="mb-6 py-4" style="font-size: 14pt; text-align: center" @click="() => this.publicationType = 'multiple'">
          REPORTES DE MULTIPLES MUNICIPIOS
        </v-btn>
      </div>

      <div style="display: flex; flex-wrap: wrap" v-if="publicationType === 'single'">
        <div
          v-for="pub in publicaciones"
          :key="pub.Id"
          style="width: 50%; position: relative; cursor: pointer"
          @click="irPublicacion(pub.Id)"
        >
          <v-img :src="pub.Data.LinkImage" height="500">
            <div class="fill-height bottom-gradient"></div>
          </v-img>
          <div
            style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "
          >
            <div
              style="display: flex; flex-direction: column; align-items: center"
            >
              <v-card color="white" width="380">
                <v-card-text>
                  <h2
                    class="mb-4 mt-3"
                    style="text-transform: uppercase; text-align: center"
                  >
                    {{ pub.Name.es }}
                  </h2>
                  <div class="mb-4" style="text-align: center; font-size: 12pt">
                    {{ pub.FechaRegistro | date }}
                  </div>
                  <p
                    class="mb-4"
                    style="
                      font-size: 14pt;
                      text-align: center;
                      line-height: 25px;
                    "
                  >
                    {{ pub.Introduction.es | truncate(150, "...") }}
                  </p>
                  <div
                    class="mt-5"
                    style="display: flex; justify-content: center"
                  >
                    <v-chip
                      color="transparent"
                      class="mr-2"
                      style="color: #f15a24; text-transform: uppercase"
                      >{{ pub.Indices.length }} Indices</v-chip
                    >
                    <v-chip
                      color="transparent"
                      style="color: #f15a24; text-transform: uppercase"
                      >{{ pub.Variables.length }} Variables</v-chip
                    >
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </div>
      </div>

      <div style="display: flex; flex-wrap: wrap" v-else>
        <div
          v-for="pub in publicacionesMultiples"
          :key="pub.Id"
          style="width: 50%; position: relative; cursor: pointer"
          @click="irPublicacionMultiple(pub.Id)"
        >
          <v-img :src="pub.Data.LinkImage" height="500">
            <div class="fill-height bottom-gradient"></div>
          </v-img>
          <div
            style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "
          >
            <div
              style="display: flex; flex-direction: column; align-items: center"
            >
              <v-card color="white" width="380">
                <v-card-text>
                  <h2
                    class="mb-4 mt-3"
                    style="text-transform: uppercase; text-align: center"
                  >
                    {{ pub.Name.es }}
                  </h2>
                  <div class="mb-4" style="text-align: center; font-size: 12pt">
                    {{ pub.FechaRegistro | date }}
                  </div>
                  <p
                    class="mb-4"
                    style="
                      font-size: 14pt;
                      text-align: center;
                      line-height: 25px;
                    "
                  >
                    {{ pub.Introduction.es | truncate(150, "...") }}
                  </p>
                  <div
                    class="mt-5"
                    style="display: flex; justify-content: center"
                  >
                    <v-chip
                      color="transparent"
                      class="mr-2"
                      style="color: #f15a24; text-transform: uppercase"
                      >{{ pub.Indices.length }} Indices</v-chip
                    >
                    <v-chip
                      color="transparent"
                      style="color: #f15a24; text-transform: uppercase"
                      >{{ pub.Variables.length }} Variables</v-chip
                    >
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </div>
      </div>

      <!-- <v-row class="mt-4">
        <v-col v-for="pub in publicaciones" :key="pub.Id" cols="4">
          <v-card outlined @click="irPublicacion(pub.Id)">
            <v-img
              class="white--text align-end"
              height="200px"
              :src="pub.Data.LinkImage"
              gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
            >
              <v-card-title>{{ pub.Name.es }}</v-card-title>
            </v-img>
            <v-card-text>
              <div>{{ pub.Introduction.es | truncate(180, "...") }}</div>
              <div class="mt-3">
                <v-chip label class="mr-2"
                  >{{ pub.Indices.length }} Indices</v-chip
                >
                <v-chip label>{{ pub.Variables.length }} Variables</v-chip>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn  text color="indigo accent-4"
                >Ver Publicación</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row> -->
    </v-container>
    <!-- FOOTER -->
    <div>
      <div style="background: #00953b">
        <v-container>
          <v-row class="white--text">
            <v-col>
              <p style="font-size: 18pt">Contáctenos</p>
              <p>
                Sede Principal: <br />
                Tel: +57 2 4450000<br />
                Km 17 Recta Cali-Palmira CP 763537 Apartado Aéreo 6713, Cali,
                Colombia
              </p>
              <div class="mb-4">
                <v-btn dark outlined @click="irLogin" text>Administrador</v-btn>
              </div>
              <p>
                <a
                  class="white--text"
                  href="https://ciat.cgiar.org/en-donde-trabajamos/?lang=es"
                  >Contáctese con nuestras oficinas regionales y alrededor del
                  mundo</a
                >
              </p>
            </v-col>
            <v-col>
              <div
                class="d-flex flex-column justify-space-between align-center"
              >
                <v-img
                  class="mb-3"
                  src="https://ciat.cgiar.org/wp-content/uploads/2016/09/cgiar-logo200-white.png"
                  width="150"
                ></v-img>
                <p>Un Centro de Investigación de CGIAR</p>
              </div>
            </v-col>
            <v-col>
              <div
                class="d-flex flex-column justify-space-between align-center"
              >
                <v-img
                  class="mb-3"
                  src="https://ciat.cgiar.org/wp-content/uploads/Alianza_logos-ESPA%C3%91OL-04.png"
                  width="300"
                ></v-img>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div style="background: #cc3333">
        <v-container class="py-0">
          <v-row>
            <v-col>
              <div style="display: flex; align-items: center">
                <p class="mb-0 white--text">
                  Copyright © 2020 International Center for Tropical Agriculture
                  - CIAT
                </p>

                <v-spacer></v-spacer>

                <v-btn
                  v-for="link in links"
                  :key="link.icon"
                  class="mx-4"
                  dark
                  icon
                  target="_blank"
                  :href="link.url"
                >
                  <v-icon size="24px">
                    {{ link.icon }}
                  </v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/api/api";
export default {
  name: "Home",
  data() {
    return {
      publicationType: "single",
      publicaciones: [],
      publicacionesMultiples: [],
      links: [
        {
          icon: "mdi-facebook",
          url: "https://www.facebook.com/BiovIntCIAT.eng/",
        },
        {
          icon: "mdi-twitter",
          url: "https://twitter.com/BiovIntCIAT_eng",
        },
        {
          icon: "mdi-youtube",
          url: "https://www.youtube.com/user/ciatwebg",
        },
        {
          icon: "mdi-linkedin",
          url: "https://www.linkedin.com/organization-guest/company/ciat",
        },
        {
          icon: "mdi-instagram",
          url: "https://www.instagram.com/bioversityciat/",
        },
      ],
    };
  },
  mounted() {
    this.getPublicaciones();
    this.getPublicacionesMultiples();
  },
  methods: {
    async getPublicaciones() {
      try {
        const data = await api.getPublicaciones();
        if (data.data.status) {
          this.publicaciones = data.data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getPublicacionesMultiples() {
      try {
        const data = await api.getMultiplePublicaciones();
        console.log
        if (data.data.status) {
          this.publicacionesMultiples = data.data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    irPublicacion(idPublication) {
      this.$router.push({ path: `publicaciones/${idPublication}` });
    },
     irPublicacionMultiple(idPublication) {
      this.$router.push({ path: `publicaciones-multiples/${idPublication}` });
    },
    irLogin() {
      this.$router.push({ path: `admin` })
      // this.$auth.isAuthenticated
      //   ? this.$router.push({ path: `admin` })
      //   : this.$auth.loginWithRedirect();
    },
    irCiat() {
      window.open("https://ciat.cgiar.org/?lang=es", "_blank");
    },
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
    date: function (value) {
      if (!value) return "";
      return moment(value).format("DD/MM/YYYY");
    },
  },
};
</script>
<style scoped>
.bottom-gradient {
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.6) 0%,
    transparent 300px
  );
}

.repeating-gradient {
  background-image: repeating-linear-gradient(
    -45deg,
    rgba(255, 0, 0, 0.25),
    rgba(255, 0, 0, 0.25) 5px,
    rgba(0, 0, 255, 0.25) 5px,
    rgba(0, 0, 255, 0.25) 10px
  );
}
</style>

